import { render } from "./InfoContactoSection.vue?vue&type=template&id=777c7306"
import script from "./InfoContactoSection.vue?vue&type=script&lang=js"
export * from "./InfoContactoSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__